import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { environment } from '../shared/environments/environment';
import {
    ICustomFieldsConfig,
    ICustomFieldsConfigCreate,
    ICustomFieldsConfigUpdate
} from '../typing/custom-fields-config.interface';
import { CustomFieldsConfig } from '../classes/custom-fields.class';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldsService {

    constructor(private http: HttpClient) {
    }

    getCustomFieldsConfigs(query: Params): Observable<IPaginatedResponse<CustomFieldsConfig>> {
        return this.http.get<IPaginatedResponse<ICustomFieldsConfig>>(`${environment.API_BASE_PATH}/custom-fields-configs`, {params: query})
            .pipe(map(response => ({
                ...response,
                data: response.data.map(config => new CustomFieldsConfig(config))
            })));
    }

    getCustomFieldConfig(id: number): Observable<CustomFieldsConfig> {
        return this.http.get<ICustomFieldsConfig>(`${environment.API_BASE_PATH}/custom-fields-config/${id}`)
            .pipe(map(config => new CustomFieldsConfig(config)));
    }

    updateCustomFieldConfig(customFieldsConfig: ICustomFieldsConfigUpdate): Observable<ICustomFieldsConfig> {
        return this.http.put<ICustomFieldsConfig>(`${environment.API_BASE_PATH}/custom-fields-config/${customFieldsConfig.id}`, customFieldsConfig);
    }

    createCustomFieldConfig(customFieldsConfig: ICustomFieldsConfigCreate): Observable<ICustomFieldsConfig> {
        return this.http.post<ICustomFieldsConfig>(`${environment.API_BASE_PATH}/custom-fields-config`, customFieldsConfig);
    }

    deleteCustomFieldConfig(data: number[]): Observable<ICustomFieldsConfig> {
        return this.http.delete<ICustomFieldsConfig>(`${environment.API_BASE_PATH}/custom-fields-configs`, {
            body: data
        });
    }
}
